import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { ConnectionDefinition } from '../../models/connectionDefinition.model';

@Injectable({
  providedIn: 'root'
})
export class ConnectionDefinitionService {

  constructor(private http: HttpClient, private apiService: ApiService) { }

  apiUrl = `${this.apiService.apiUrl}/connectionsDefinitions`;

  getAllConnectionsDefinitions(): Observable<ConnectionDefinition[]> {
    return this.http.get<ConnectionDefinition[]>(`${this.apiUrl}/all`);
  }
}
